import { Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { NON_BREAKING_SPACE } from 'utils/constants/common';

import Link from 'bloko/blocks/link';

import useTrls from 'hooks/translation/useTrls';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import TitlePage from 'components/TitlePage';

import { useSelector } from 'store/utils';

import 'components/NotFound/NotFound.less';

const NotFound = () => {
    const email = useSelector((state) => state.clickme.email);
    const dashboardRoute = useDashboardRoute();

    const trl = useTrls();

    return (
        <Fragment>
            <TitlePage header={trl('notFound.title')} />
            <p className="not-found__item">
                {trl('notFound.part1')}
                {NON_BREAKING_SPACE}
                <Link href={`mailto:${email}`}>{email}</Link>
            </p>
            <p className="not-found__item">
                {trl('notFound.part2')}
                {NON_BREAKING_SPACE}
                <Link Element={RouterLink} to={dashboardRoute}>
                    {trl('notFound.link.myBanners')}
                </Link>
                ,{NON_BREAKING_SPACE}
                {trl('notFound.part3')}
                {NON_BREAKING_SPACE}
                <Link href="/campaign/create">{trl('notFound.link.newBanners')}</Link>
            </p>
        </Fragment>
    );
};

export default NotFound;
